<script>
  export let value;
  export let link;
  export let dark = false;
</script>

<a href={link} class='line-link' class:line-link-dark={dark}>
  <div class='line-link-box'>
      <div class='line-link-box-text'> {value} </div>

      <div class='line-link-box-line'/>
  </div>
</a>

<style>
  .line-link {
    text-decoration: none;

    color: inherit;
  }

  .line-link-box {
    position: relative;

    display: flex;
    justify-content: center;
    align-items: center;
  }

  .line-link-box-text {
    display: flex;
    align-items: center;

    height: 20px;

    padding: 5px 10px;

    z-index: 1;

    font-weight: 550;

    background: var(--white);
    color: var(--primary);
  }

  .line-link-box-line {
    position: absolute;

    width: 100%;
    height: 3px;

    background: transparent;

    transition: background 0.5s ease-in-out;
  }

  .line-link-box:hover .line-link-box-line {
    background: var(--primary);
  }

  .line-link-dark .line-link-box-text {
    background: var(--grey-1);
  }

  :global(body.dark) .line-link-box-text {
    background: var(--grey-9);
    color: var(--tertiary-dark);
  }

  :global(body.dark) .line-link-box:hover .line-link-box-line {
    background: var(--tertiary-dark);
  }

  :global(body.dark) .line-link-dark .line-link-box-text {
    background: var(--grey-8);
    color: var(--tertiary);
  }

  :global(body.dark) .line-link-dark .line-link-box:hover .line-link-box-line {
    background: var(--tertiary);
  }
</style>
